<template>
  <div
    ref="numberCard"
    class="number-card"
    :class="{'card-click': isCardClick, 'is-loading': isloading}"
    @click="onClickCard()"
  >
    <div
      v-if="add"
      class="add-btn"
      :class="{'is-loading': isloading}"
      @click.stop.prevent="onClick()"
    >
      <i class="icon-add" />
    </div>
    <div ref="flexbox">
      <LvFlexBox class="pa-16" :class="{'pr-32': isTitleTooLong}">
        <img
          v-if="leadingImg"
          :src="leadingImg"
          alt=""
          :style="{width: '1.5rem'}"
        >
        <div class="number-card__title-wrap">
          <LvText
            v-if="title && !isloading"
            h6
            bold
            wrap
          >{{ $t(title) }}</LvText>
          <p
            v-if="!isloading"
            class="num"
          >
            {{ C_number }}<span
              v-if="hasPercent"
              class="percent"
            >%</span>
          </p>
        </div>
      </LvFlexBox>
    </div>
    <div
      v-if="isloading"
      class="isloading-wrap"
    >
      <SkeletonAnimate class="skeleton skeleton1" />
      <SkeletonAnimate class="skeleton skeleton2" />
    </div>
  </div>
</template>
<script>
export default {
  name: "NumberCard",
  props: {
    isCardClick: {
      type: Boolean,
      default: false,
    },
    add: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    number: {
      type: Number,
      default: 0,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    hasPercent: {
      type: Boolean,
      default: false,
    },
    leadingImg: {
      type: String,
    }
  },
  data() {
    return {
      C_number: 0,
      isTitleTooLong: false,
    };
  },
  watch: {
    number() {
      this.C_number = this.number;
    },
  },
  mounted() {
    this.C_number = this.number;
    this.$_getIsTitleTooLong();
    window.addEventListener("resize", this.$_getIsTitleTooLong);
  },
  beforeDestroy() {
    window.addEventListener("resize", this.$_getIsTitleTooLong);
  },
  methods: {
    onClick() {
      if (this.isloading) return;
      this.$emit("click");
    },
    onClickCard() {
      if (this.isloading) return;
      this.$emit("clickCard");
    },
    $_getIsTitleTooLong() {
      if (!this.$refs.numberCard || !this.$refs.flexbox) this.isTitleTooLong = false;
      else {
        const numberCardWidth = this.$refs.numberCard.clientWidth;
        const flexboxWidth = this.$refs.flexbox.clientWidth - 32;
        this.isTitleTooLong =  numberCardWidth - flexboxWidth <= 32;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/number-card";
</style>